// 자막 이름표 자동 생성 — 펫 메타(context.virtupetProfile)에서 "이름 / 나이세" 텍스트를 만든다.
//  메타가 없거나 이름이 없으면 null → 이름표 숨김 (null/undefined 문자열이 화면에 노출되지 않도록 여기서 차단)
export function petNameTagText(profile) {
  if (!profile || !profile.name) return null;
  const age = profile.age;
  if (age !== null && age !== undefined && age !== "") return `${profile.name} / ${age}세`;
  return String(profile.name);
}
